import kea = require('node_modules/kea-react/dist/index');
import models = require("app/models/requireme");
import { rpcController } from "../rpc";
import { cacheResource, bindResource, rpcCrudService } from "kea-resource";
import { CampoRepetidoIdentificacion, ResourceIdentificacionRepetido } from "./identificacion";

const controller = rpcController("LibroAdministracion");

/**Resource del reporte de guias documentadas y del inventario de sucursal */
export const RepLibroAdministracion = cacheResource({
    Generar: async (parametros: models.ParamsLibroAdministracion): Promise<string> => await controller("GenerarLibroAdministracion", {}, parametros),
}, {
    }, {

    })


// WEBPACK FOOTER //
// ./app/resources/items/reportelibroadministracion.tsx